//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'SideServices',
    data: () => ({
        services: [],
        servicesKey: false,
        options: {
            loop: true,
            lazy: true,
            autoplay:{
              delay:2500,
              disableOnInteraction:false,
            },
          slidesPerView: 1,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            }
        },
    }),

    async created() {
        this.servicesKey = false
        const response = await this.$api.fetchMedicalSections()
        this.services = response.content.data
        this.servicesKey = true
    },
}
